import { call, delay, put, takeLatest } from "redux-saga/effects";

// requests
import { createRoleApi, editRoleDataByIdApi, getRoleDataByIdApi, getRoleListApi } from "../../requests/master/roleRequests";

// actions
import { setPostApiStatus, setPutApiStatus } from "../../../actions/apiStatusActions";
import { getRoleList, setRoleDataById, setRoleList, setRoleListPageCount } from "../../../actions/master/roleActions";

import { RoleActionTypes, RoleActions } from "../../../actionTypes/master/roleActionTypes";
import { startLoader, stopLoader } from "../../../../utils/commonFunctions";

// for toast
import { toast } from "react-toastify";


function* createRoleHandler(action: RoleActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(createRoleApi, action.payload);
    if (data.status) {
      toast.success(data?.message, {
        position: "top-right",
      });
      yield put(setPostApiStatus(true));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
    yield put(setPostApiStatus(false));
  } finally {
    yield stopLoader("transparent");
  }
}

function* getRoleListHandler(action: RoleActionTypes) {
  if(action.payload.search){
    yield delay(500); //to hit search api after 500ms of the last key stroke
  }
  try {
    yield startLoader("transparent");
    const { data } = yield call(getRoleListApi, action.payload);
    if (data.status) {
      yield put(setRoleList(data?.data?.rows));
      yield put(setRoleListPageCount(data?.data?.count ?? 0));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
  } finally {
    yield stopLoader("transparent");
  }
}

function* getRoleDataByIdHandler(action: RoleActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(getRoleDataByIdApi, action.payload);
    if (data.status) {
      yield put(setRoleDataById(data?.data));
    } else {
      toast.error(data?.message, {
        position: "top-right",
      });
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
  } finally {
    yield stopLoader("transparent");
  }
}

function* editRoleDataByIdHandler(action: RoleActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(editRoleDataByIdApi, action.payload);
    if (data.status) {
      toast.success(data.message, {
        position: "top-right",
      });
      yield put(setPutApiStatus(true));
      yield put(getRoleList({ page: 0, pageLimit: 10, departmentId: 0 }));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
    yield put(setPutApiStatus(false));
  } finally {
    yield stopLoader("transparent");
  }
}

export default function* roleSaga() {
  yield takeLatest(RoleActions.CREATE_ROLE, createRoleHandler);
  yield takeLatest(RoleActions.GET_ROLE_LIST, getRoleListHandler);
  yield takeLatest(RoleActions.GET_ROLE_DATA_BY_ID, getRoleDataByIdHandler);
  yield takeLatest(RoleActions.EDIT_ROLE_DATA_BY_ID, editRoleDataByIdHandler);
}
